import { BorderConfig, BoxShadowConfig, ColorConfig, SizeConfig, SpacingConfig } from '../shared';
import { TextComponentConfig } from '../text';
import { TimePickerFormat } from './time-picker-format.enum';

export interface TimePickerComponentConfig {
  borderSettings: BorderConfig;
  customSizeSettings: SizeConfig;
  shadowSettings: BoxShadowConfig;
  paddingSettings: SpacingConfig;
  marginSettings: SpacingConfig;
  text: TextComponentConfig;
  format?: TimePickerFormat;
}
